"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationUpdate = void 0;
class IntegrationUpdate {
    constructor() {
    }
    static getAttributeTypeMap() {
        return IntegrationUpdate.attributeTypeMap;
    }
}
exports.IntegrationUpdate = IntegrationUpdate;
IntegrationUpdate.discriminator = undefined;
IntegrationUpdate.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=IntegrationUpdate.js.map